import axios from 'axios';

const API_URL = 'https://cnrevtawb7.execute-api.us-west-2.amazonaws.com/prod/api/';

const api = axios.create({
  baseURL: API_URL,
});

export default api; 